export enum BetType {
  Straight,
  Split,
  Corner,
  Street,
  DoubleStreet,
  Row,
  Dozen,
  Low,
  High,
  Even,
  Odd,
  Red,
  Black,
  Five,
}
